import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as FormConst from '../../../../constants/FormConst'
import * as BrandConst from '../../../../constants/BrandConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import HotelContactsService from '../../../../services/HotelContactsService'
import {isCompletedHotelInfoHistory, searchObjectList} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Card from '../../../molecules/Card/Card'
import MultiCard from '../../../molecules/Card/MultiCard'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './HotelContacts.scss'

class HotelContacts extends Component {

    constructor(props) {
        super(props)

        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        const brandName = hotelInfo.brandName
        const isHotelDomestic = getSessionItem(SessionConst.IS_HOTEL_DOMESTIC)
        const user = getSessionItem(SessionConst.USER)

        const isHotelContact = user.isHotelContact

        if (!hotelCode || !hotelInfo) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.onClickActionButton = this.onClickActionButton.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.deleteContact = this.deleteContact.bind(this)
        this.processContactsResponse = this.processContactsResponse.bind(this)

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            brandName: brandName,
            isHotelDomestic: isHotelDomestic,
            hotelContacts: undefined,
            error: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showDeleteModal: false,
            deleteIndex: -1,
            showErrorModal: false,
            hotelContactStatus: {
                'Onboarding': 'Pending',
                'Opening Service Director': 'Pending',
                'Online Travel Agent': 'Pending',
                'Emergency': 'Pending'
            },
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            isHotelContact: isHotelContact
        }
    }

    headers = ['Hotel Contact Type', 'Action']

    hotelContactRoutes = {
        'Onboarding': RouteConst.ROUTE_ONBOARDING_CONTACT,
        'Opening Service Director': RouteConst.ROUTE_OSD_CONTACT,
        'Online Travel Agent': RouteConst.ROUTE_ONLINE_TRAVEL_AGENT_CONTACT,
        'Emergency': RouteConst.ROUTE_EMERGENCY_CONTACTS_PAGE
    }

    hotelContactLabels = {
        'Emergency': FormConst.LABEL_HOTEL_CONTACT_TYPE_EMERGENCY_CONTACTS,
        'Onboarding': FormConst.LABEL_HOTEL_CONTACT_TYPE_ONBOARDING_CONTACT,
        'Opening Service Director': FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR,
        'Online Travel Agent': FormConst.LABEL_HOTEL_CONTACT_TYPE_ONLINE_TRAVEL_AGENT
    }

    onClickActionButton = () => {
        // Get the first pending item
        let isPending = false
        let pendingType = 'Emergency'
        for (const type in this.state.hotelContactStatus) {
            if (this.state.hotelContactStatus.hasOwnProperty(type)) {
                const status = this.state.hotelContactStatus[type];
                if ((type === 'Online Travel Agent'  && (this.state.isHotelDomestic === FormConst.VALUE_YES && this.state.brandName != BrandConst.BRAND_NAME_WOODSPRING)) 
                    || (this.state.isHotelContact && type === 'Opening Service Director')) {
                    continue
                } else if (status === 'Pending') {
                    pendingType = type
                    isPending = true
                    break
                }
            }
        }
        if (isPending) {
            // Got to the page
            this.props.history.push({
                pathname: this.hotelContactRoutes[pendingType],
                state: {
                    continueFlow: true
                }
            })
        } else {
            // Got to the page
            this.props.history.push(RouteConst.ROUTE_HOTEL_ONLINE_DISPLAY_PAGE)
        }
    }

    handleDelete = (type, index) => {
        this.setState({
            showDeleteModal: true,
            deleteType: type,
            deleteIndex: index
        })
    }

    async componentDidMount() {
		 if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
			 let contactsObjectSession = this.state.hotelInfoCompletedHistory.newEntity.contacts
			 this.processContactsResponse(contactsObjectSession.contacts)
		 }
		 else{
			 await HotelContactsService.getHotelContacts({ hotelCode: this.state.hotelCode })
			 .then(response => {
	        	if (response.contacts) {
	        		this.processContactsResponse(response.contacts)
	            } else {
	                this.setState({ hotelContacts: [], isLoading: false })
	            }
	        }).catch(error => {
	            this.setState({
	                isLoading: false,
	                showErrorModal: true,
	                errorMessage: 'There was an error while retrieving Hotel Contacts data'
	            })
	        })
		 }
    }

    deleteContact = () => {

        let type = this.state.deleteType
        let index = this.state.deleteIndex

        let newContacts = []
        let newEmergencyContacts = this.state.emergencyContacts
        let newOnboardingContact = this.state.onboardingContact
        let newOsdContact = this.state.osdContact
        let newOtaContact = this.state.otaContact
        if (type === 'Onboarding') {
            newOnboardingContact = undefined
        } else if (type === 'Opening Service Director') {
            newOsdContact = undefined
        } else if (type === 'Online Travel Agent') {
            newOtaContact = undefined
        } else {
            newEmergencyContacts = [...this.state.emergencyContacts]
            newEmergencyContacts.splice(index, 1)
        }

        if (newOnboardingContact) {
            newContacts = newContacts.concat(newOnboardingContact)
        }

        if (newOsdContact) {
            newContacts = newContacts.concat(newOsdContact)
        }

        if (newOtaContact) {
            newContacts = newContacts.concat(newOtaContact)
        }

        if (newEmergencyContacts && newEmergencyContacts.length > 0) {
            newContacts = newContacts.concat(newEmergencyContacts)
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newContacts })

        this.setState({
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            pendingHotelContacts: newContacts,
            pendingOnboardingContact: type === 'Onboarding' ? undefined : this.state.onboardingContact,
            pendingOsdContact: type === 'Opening Service Director' ? undefined : this.state.osdContact,
            pendingOtaContact: type === 'Online Travel Agent' ? undefined : this.state.otaContact,
            pendingEmergencyContacts: type === 'Emergency' ? newEmergencyContacts : this.state.emergencyContacts,
            showDeleteModal: false,
            error: undefined
        })
    }

    async processContactsResponse (contactsObject) {
    	
    	let onboardingContact
        let osdContact
        let otaContact
        let emergencyContacts = []

    	contactsObject.forEach(contact => {
            if (contact.type === 'Onboarding') {
                onboardingContact = contact
            } else if (contact.type === 'Opening Service Director') {
                osdContact = contact
            } else if (contact.type === 'Online Travel Agent') {
                otaContact = contact
            } else {
                emergencyContacts.push(contact)
            }
        })
        this.setState({
            hotelContacts: contactsObject,
            onboardingContact: onboardingContact,
            osdContact: osdContact,
            otaContact: otaContact,
            emergencyContacts: emergencyContacts,
            error: undefined,
            isLoading: false,
            hotelContactStatus: {
                'Onboarding': onboardingContact ? 'Complete' : 'Pending',
                'Opening Service Director': osdContact ? 'Complete' : 'Pending',
                'Online Travel Agent': otaContact ? 'Complete' : 'Pending',
                'Emergency': emergencyContacts && emergencyContacts.length > 0 ? 'Complete' : 'Pending'
            }
        })


    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    pendingHotelContacts: undefined,
                    pendingOnboardingContact: undefined,
                    pendingOsdContact: undefined,
                    pendingOtaContact: undefined,
                    pendingEmergencyContacts: undefined,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription
                })
            } else {
                this.setState({
                    isLoading: false,
                    hotelContacts: this.state.pendingHotelContacts,
                    onboardingContact: this.state.pendingOnboardingContact,
                    osdContact: this.state.pendingOsdContact,
                    otaContact: this.state.pendingOtaContact,
                    emergencyContacts: this.state.pendingEmergencyContacts,
                    pendingHotelContacts: undefined,
                    pendingOnboardingContact: undefined,
                    pendingOsdContact: undefined,
                    pendingOtaContact: undefined,
                    pendingEmergencyContacts: undefined,
                    error: undefined,
                    hotelContactStatus: {
                        'Onboarding': this.state.pendingOnboardingContact ? 'Complete' : 'Pending',
                        'Opening Service Director': this.state.pendingOsdContact ? 'Complete' : 'Pending',
                        'Online Travel Agent': this.state.pendingOtaContact ? 'Complete' : 'Pending',
                        'Emergency': this.state.pendingEmergencyContacts && this.state.pendingEmergencyContacts.length > 0 ? 'Complete' : 'Pending'
                    }
                })
            }
        }
    }

    render() {
        let buttonName = 'Proceed'
        let buttonClass = 'proceed'
        let onboardingCard
        let osdCard
        let otaCard
        let emergencyCard

        let isComplete = true

        if (!this.state.hotelContacts || this.state.hotelContacts.length === 0) {
            buttonName = 'Start Editing'
            buttonClass = 'proceed'
            isComplete = false
        } else {
            for (const type in this.state.hotelContactStatus) {
                if (this.state.hotelContactStatus.hasOwnProperty(type)) {
                    const status = this.state.hotelContactStatus[type];
                    if (type === 'Online Travel Agent'  && (this.state.isHotelDomestic === FormConst.VALUE_YES && this.state.brandName != BrandConst.BRAND_NAME_WOODSPRING)) {
                        isComplete = isComplete
                    } else {
                        isComplete = isComplete && status === 'Complete'
                    }
                }
            }

            if (isComplete) {
                buttonName = 'Next Section'
                buttonClass = 'complete'

            } else {
                buttonName = 'Continue Editing'
                buttonClass = 'proceed'
            }
        }

        for (const type in this.state.hotelContactStatus) {
            if (this.state.hotelContactStatus.hasOwnProperty(type)) {

                const contactsForType = searchObjectList('type', type, this.state.hotelContacts)
                let cardsDataForType

                if (contactsForType && contactsForType.length > 0) {
                    cardsDataForType = contactsForType.map((contact, index) => {

                        let phoneNumberObject
                        let phoneNumber
                        let emailObject
                        let email
                        let emergencyPriority

                        if (contact.phoneNumbers && contact.phoneNumbers.length > 0) {
                            phoneNumberObject = contact.phoneNumbers[0]
                            phoneNumber = '+('
                                + phoneNumberObject.countryCode
                                + ') '

                            if (phoneNumberObject.areaCode) {
                                phoneNumber += '(' + phoneNumberObject.areaCode + ') '
                            }
                            phoneNumber += phoneNumberObject.number
                        }

                        if (contact.emailAddresses && contact.emailAddresses.length > 0) {
                            emailObject = contact.emailAddresses[0]
                            email = emailObject.address
                        }
                        let actions
                        if (type === 'Emergency') {
                            emergencyPriority = contact.emergencyPriority
                            actions = [{
                                'onClick': () => this.props.history.push({
                                    pathname: this.hotelContactRoutes[type],
                                    state: {
                                        isEdit: true,
                                        editIndex: index,
                                        showNewFields: true
                                    }
                                }),
                                'label': 'Edit'
                            },
                            {
                                'onClick': () => this.handleDelete(type, index),
                                'label': 'Delete'
                            }]
                        } else {
                            actions = [{
                                'onClick': () => this.props.history.push(this.hotelContactRoutes[type]),
                                'label': 'Edit'
                            },
                            {
                                'onClick': () => this.handleDelete(type, index),
                                'label': 'Delete'
                            }]
                        }
                        return {
                            // header: contact.type,
                            title: contact.firstName + ' ' + contact.lastName,
                            text: (
                                <dl>
                                    {
                                        contact.title && (
                                            <>
                                                <dt>Title</dt>
                                                <dd>{contact.title}</dd>
                                            </>
                                        )
                                    }
                                    {
                                        phoneNumber && (
                                            <>
                                                <dt>Phone Number</dt>
                                                <dd>{phoneNumber}</dd>
                                            </>
                                        )
                                    }
                                    {email
                                        && (
                                            <>
                                                <dt>Email</dt>
                                                <dd>{email}</dd>
                                            </>
                                        )}
                                    {emergencyPriority
                                        && (
                                            <>
                                                <dt>Priority</dt>
                                                <dd>{emergencyPriority}</dd>
                                            </>
                                        )}
                                </dl>
                            ),
                            actions: actions,
                            isSmall: true
                        }
                    })
                }

                if (type === 'Opening Service Director') {
                    osdCard = cardsDataForType?.length > 0
                        ? <Card
                            id='osd-card'
                            header={this.hotelContactLabels[type]}
                            title={cardsDataForType[0].title}
                            text={cardsDataForType[0].text}
                            actions={cardsDataForType[0].actions}
                            isFill />
                        : <Card
                            id='osd-card'
                            header={this.hotelContactLabels[type]}
                            title={`No ${FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR} contact details. Click add to enter the details.`}
                            data={[]}
                            actions={[{ 'onClick': () => this.props.history.push(this.hotelContactRoutes[type]), 'label': `(+) Add ${FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}` }]}
                            isFill />
                } else if (type === 'Onboarding') {
                    onboardingCard = cardsDataForType?.length > 0
                        ? <Card
                            id='onboarding-card'
                            header={this.hotelContactLabels[type]}
                            title={cardsDataForType[0].title}
                            text={cardsDataForType[0].text}
                            actions={cardsDataForType[0].actions}
                            isFill />
                        : <Card
                            id='onboarding-card'
                            header={this.hotelContactLabels[type]}
                            title={`No Hotel Contact details. Click add to enter the details.`} data={[]}
                            actions={[{ 'onClick': () => this.props.history.push(this.hotelContactRoutes[type]), 'label': '(+) Add Hotel Contact' }]}
                            isFill />
                } else if (type === 'Online Travel Agent'  && (this.state.brandName === BrandConst.BRAND_NAME_WOODSPRING || this.state.isHotelDomestic === FormConst.VALUE_NO)) {
                    otaCard = cardsDataForType?.length > 0
                        ? <Card
                            id='ota-card'
                            header={this.hotelContactLabels[type]}
                            title={cardsDataForType[0].title}
                            text={cardsDataForType[0].text}
                            actions={cardsDataForType[0].actions}
                            isFill />
                        : <Card
                            id='ota-card'
                            header={this.hotelContactLabels[type]}
                            title={`No OTA Contact details. Click add to enter the details.`} data={[]}
                            actions={[{ 'onClick': () => this.props.history.push(this.hotelContactRoutes[type]), 'label': '(+) Add OTA Contact' }]}
                            isFill />
                } else {
                    const emergencyCardFooter = `You can add up to ${FormConst.MAX_EMERGENCY_CONTACTS} Emergency Contacts. At least one Emergency Contact is required.`
                    emergencyCard = cardsDataForType?.length > 0
                        ? <MultiCard
                            id='emergency-card'
                            header={this.hotelContactLabels[type]}
                            data={cardsDataForType}
                            actions={cardsDataForType.length < FormConst.MAX_EMERGENCY_CONTACTS ? [{
                                'onClick': () => this.props.history.push({
                                    pathname: this.hotelContactRoutes[type],
                                    state: {
                                        isEdit: false,
                                        editIndex: -1,
                                        showNewFields: true
                                    }
                                }), 'label': '(+) Add Emergency Contact'
                            }] : []}
                            footer={emergencyCardFooter}
                            isFill />
                        : <MultiCard
                            id='emergency-card'
                            header={this.hotelContactLabels[type]}
                            title={`No Emergency Contact details. Click add to enter the details.`}
                            data={[]}
                            actions={[{ 'onClick': () => this.props.history.push(this.hotelContactRoutes[type]), 'label': '(+) Add Emergency Contact' }]}
                            footer={emergencyCardFooter}
                            isFill />
                }
            }
        }

        return (
            <div className='hotel-contacts-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Hotel Contacts</li>
                    </ol>
                </nav>
                {
                    !this.state.isLoading
                    && (
                        <div className='contact-cards'>
                            <Row className='justify-content-start'>
                                <Col xs={12} className='helper-text'>
                                    <p>{FormConst.HOTEL_CONTACTS_ONBOARDING_OPD_HELPER_TEXT}</p>
                                </Col>
                                <Col className='d-flex box card-onboarding' xs={12} sm={12} md={12} lg={6} xl={6} >
                                    {onboardingCard}
                                </Col>
                                {!this.state.isHotelContact
                                    && (
                                        <Col className='d-flex box card-osd' xs={12} sm={12} md={12} lg={6} xl={6}>
                                            {osdCard}
                                        </Col>
                                )}
                                <Col className='d-flex box card-ota' xs={12} sm={12} md={12} lg={6} xl={6}>
                                    {otaCard}
                                </Col>
                            </Row>
                            <Row className='justify-content-start card-emergency'>
                                <Col xs={12}>
                                    <p className='helper-text'>{FormConst.HOTEL_CONTACTS_EMERGENCY_HELPER_TEXT}</p>
                                </Col>
                                <Col xl={12} className='d-flex box'>
                                    {emergencyCard}
                                </Col>
                            </Row>
                        </div>
                    )
                }
                <br />
                {
                    !this.state.isLoading && isComplete
                    && (
                        <div className="alert alert-success" role="alert">
                            <h4 className="alert-heading">Well done!</h4>
                            <p>You successfully finished this module. Let's proceed to the <NavLink to={SideNavEntryMapping.HOTEL_TEXT.current.route} className='alert-link'>next</NavLink> module</p>
                        </div>
                    )
                }

                <FormFooter
                    form={SideNavEntryMapping.CONTACTS}
                    submitName={buttonName}
                    onSubmit={this.onClickActionButton}
                    noReset />
                <FormModal
                    id='hotel-contacts-page-loading-modal'
                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                    hotelInfo={this.state.hotelInfo}
                    body={<h6>{this.state.loadingMessage}</h6>}
                    show={this.state.isLoading}
                    isLoadingIndicator />
                <FormModal
                    id='hotel-contacts-page-delete-modal'
                    hotelInfo={this.state.hotelInfo}
                    title='Delete Contact'
                    body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                    proceed={this.deleteContact}
                    cancel={() => { this.setState({ showDeleteModal: false, deleteIndex: -1 }) }}
                    show={this.state.showDeleteModal} />
                <FormModal
                    id='hotel-contacts-page-error-modal'
                    hotelInfo={this.state.hotelInfo}
                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                    body={<h5>{this.state.errorMessage}</h5>}
                    isError
                    cancel={() => { this.setState({ showErrorModal: false }) }}
                    show={this.state.showErrorModal} />
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        hotelContactsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_HOTEL_CONTACTS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_CONTACTS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(HotelContacts, SideNavEntryMapping.CONTACTS))